<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Edit Bill</h5>
      <button
        type="button"
        class="btn-close"
        ref="modalCloseBtn"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <form @submit.prevent="updateBill()">
      <div class="modal-body">
        <div class="partner-modal-section">
          <div class="form-group">
            <label for="">Transaction ID: </label> <br />
            <input
              type="text"
              class="form-control"
              v-model="formValue.transaction_code"
              required
              maxlength="50"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-cancel"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../../config/axios';

export default {
  props: ['payment'],
  data() {
    return {
      isLoading: false,
      formValue: {
        transaction_code: ''
      }
    };
  },
  watch: {
    payment: {
      handler: function () {
        this.setFormValue();
      },
      deep: true
    }
  },
  methods: {
    setFormValue() {
      this.formValue.transaction_code = this.payment?.transaction_code;
    },
    updateBill() {
      this.isLoading = true;
      http
        .patch(
          `v2/partners/bills/update/${this.payment?.bills_id}`,
          this.formValue
        )
        .then((response) => {
          this.isLoading = false;
          this.$refs.modalCloseBtn.click();
          this.$emit('refreshData');
          this.$partnerSwal.quickSuccessAlert.fire({
            title: 'Success!',
            text: response.data?.message
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response?.data?.message
          });
        });
    }
  }
};
</script>

<style scoped></style>
